/**
 * Where to go after signing in (?volver=). Only same-site paths are accepted, so
 * a crafted link cannot send the user to another site after the login (open redirect).
 */
export function safeReturnPath(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\'))
    return '/';
  return value;
}

/**
 * Reads the token from the link's fragment (#t=...) and removes it from the address
 * bar and history, so it is not left visible, bookmarked or shared by mistake.
 */
let taken: { path: string; token: string | null } | null = null;

export function takeTokenFromHash(): string | null {
  // Cached per page: React may call initializers twice (StrictMode), and the hash is
  // already gone the second time.
  if (taken?.path === window.location.pathname && !window.location.hash) return taken.token;
  const match = /^#t=([A-Za-z0-9_-]{20,200})$/.exec(window.location.hash);
  if (window.location.hash) {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  }
  taken = { path: window.location.pathname, token: match?.[1] ?? null };
  return taken.token;
}

/** Full page load (used when the session cookie changes, e.g. impersonation). */
export function reloadAt(path: string): void {
  window.location.assign(path);
}
